import { PlatformAndroid16, PlatformApple16 } from 'ui/icons/aurora/16px';
import { Desktop24 } from 'ui/icons/aurora/24px/Desktop24';
import { OTT } from 'ui/icons/devices/OTT';
import { AppPlatform } from '../types';

export const ANDROID_DATA_TEST = 'android-icon';
export const APPLE_DATA_TEST = 'apple-icon';
export const WEB_DATA_TEST = 'web-icon';
export const OTT_DATA_TEST = 'ott-icon';

type Props = {
  platformType: AppPlatform;
  width?: string | number;
  height?: string | number;
  color?: string;
};

export const AppIcon = ({ platformType, width = 24, height = 24, color }: Props) => {
  let PlatformIconCmp;
  let dataTestId;

  switch (platformType) {
    case AppPlatform.ANDROID:
      PlatformIconCmp = PlatformAndroid16;
      dataTestId = ANDROID_DATA_TEST;
      break;
    case AppPlatform.IOS:
      PlatformIconCmp = PlatformApple16;
      dataTestId = APPLE_DATA_TEST;
      break;
    case AppPlatform.WEB:
      PlatformIconCmp = Desktop24;
      dataTestId = WEB_DATA_TEST;
      break;
    case AppPlatform.OTT:
      PlatformIconCmp = OTT;
      dataTestId = OTT_DATA_TEST;
      break;
    default:
      return null;
  }

  return <PlatformIconCmp data-test={dataTestId} width={width} height={height} color={color} />;
};
